export default {
  computed: {
    isBrowserJapanese: function(){
      return window.navigator.language == "ja" || window.navigator.language == "ja-jp";
    },
  }
}